import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "../../lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center", className)}
    {...props}>
    <SliderPrimitive.Track
      className="relative h-2 w-full grow overflow-hidden rounded-full"
      style={{ backgroundColor: 'rgba(158, 180, 192, 0.25)' }}>
      <SliderPrimitive.Range 
        className="absolute h-full" 
        style={{ 
          background: 'linear-gradient(90deg, #00f4ff 0%, #12b7ff 100%)',
          boxShadow: '0 0 8px rgba(0, 244, 255, 0.4)'
        }} />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className="block h-5 w-5 rounded-full shadow-lg transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00f4ff] disabled:pointer-events-none disabled:opacity-50 hover:scale-110" 
      style={{ 
        backgroundColor: '#ffffff',
        border: '2px solid #00f4ff',
        boxShadow: '0 0 12px rgba(0, 244, 255, 0.6), 0 2px 4px rgba(0, 0, 0, 0.3)'
      }} />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
